module.exports = __webpack_public_path__ + "static/media/criativos_masculino_roupas.c18bc54c.jpg";